export default __webpack_public_path__ + "static/media/backgroundTransaksi.e7621754.png";